import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
// Order matters: tokens define the custom properties primitives.css
// consumes, and both must land before any component stylesheet.
import './styles/tokens.css';
import './styles/primitives.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <App />
  </Router>
);
